import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100 mt-auto">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-lg font-bold leading-none">
                绍
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                绍宋<span className="text-accent-500">.</span>
              </span>
            </div>
            <p className="text-sm leading-6 text-primary-200 max-w-md">
              绍宋影视大全致力于汇集最新电影与电视剧资源，提供清晰的分类导航和详尽的剧情介绍，帮助影迷快速找到想看的作品。本站为内容浏览演示平台，不含视频播放与下载功能。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-3">
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                快速导航
              </Link>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/category/movie" className="hover:text-accent-400 transition-colors">电影</Link></li>
              <li><Link to="/category/tvshow" className="hover:text-accent-400 transition-colors">电视剧</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 transition-colors">搜索</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-3">
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                联系我们
              </Link>
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
                <a href="mailto:hello@shaosong-tv.example" className="hover:text-accent-400 transition-colors">
                  hello@shaosong-tv.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
                <span>浙江省杭州市</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                <span>每日 09:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 绍宋影视大全 · 内容仅供学习交流演示</p>
          <p>本站搜索结果与收藏功能均为前端演示，数据存储于当前设备浏览器</p>
        </div>
      </div>
    </footer>
  );
}